module.exports = {
  //API_ENDPOINT: "http://localhost:8000/api",
  API_ENDPOINT: "https://radiant-lowlands-24877.herokuapp.com/api",
  TOKEN_KEY: "thinktank-token",
};
